// Local (hotseat / solo-vs-AI) games have no Firebase project to persist
// them, unlike remote games which are already saved server-side on every
// action (see store/index.js's submitAction). This is the equivalent for
// local play: the browser's own localStorage, so closing the tab and coming
// back later (even a full browser restart) resumes exactly where you left
// off, the same way a remote game does.
const STORAGE_KEY = 'thunderstoner:localGame:v1';

// localStorage can throw (Safari private browsing, quota exceeded, disabled
// entirely) - persistence here is a nicety, never worth breaking gameplay
// over, so every call is best-effort and silently degrades to "not saved."
function safeLocalStorage() {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch {
    return null;
  }
}

export function readLocalGame() {
  const storage = safeLocalStorage();
  if (!storage) return null;
  try {
    const raw = storage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Could not read saved local game:', err.message);
    return null;
  }
}

export function writeLocalGame(gameState) {
  const storage = safeLocalStorage();
  if (!storage) return;
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(gameState));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Could not save local game:', err.message);
  }
}

export function clearLocalGame() {
  const storage = safeLocalStorage();
  if (!storage) return;
  try {
    storage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to do - if removal fails, the next writeLocalGame() call will
    // just overwrite the stale entry anyway.
  }
}
